import { defineMessages } from 'react-intl';

const messages = defineMessages({
  sectionTitle: {
    description: 'Label for the title representing the shipment details section',
    defaultMessage: 'Shipment Details',
    id: '7qDoBz',
  },
  sectionAriaLabel: {
    description: 'Aria label for the expandable shipment details section',
    defaultMessage: 'Shipment Details expander section',
    id: 'RHmymS',
  },
  shipmentCounter: {
    description: 'Label for the title representing the shipment details section',
    defaultMessage: 'Shipment {count} (of {total})',
    id: 'VlSjxU',
  },
  shipToAddress: {
    description: 'Label for the address that the shipment will be sent to',
    defaultMessage: 'Ship To Address',
    id: 'YUw5yS',
  },
  editShipToAddressButton: {
    description: 'Label for the button that will edit an address',
    defaultMessage: 'Edit',
    id: 'm4HTJN',
  },
  shipmentHeader: {
    description: 'Label for the shipment column in the edit amounts modal',
    defaultMessage: 'Shipment',
    id: 'Na/czl',
  },
  emptyDateMessage: {
    description: 'Placeholder text for a Date Picker input that tells the user the input will set a Date value',
    defaultMessage: 'Set Date',
    id: '0hDh1E',
  },
  shipByDate: {
    description: 'Label for the date the order should be shipped by',
    defaultMessage: 'Ship By',
    id: 'ofnHJK',
  },
  deliverByDate: {
    description: 'Label for the date of the order should be delivered by',
    defaultMessage: 'Deliver By',
    id: 'BLKaBF',
  },
  holdUntilDate: {
    description: 'Label for the date that the order is on hold until',
    defaultMessage: 'Hold Until',
    id: 'gRp0u4',
  },
  holdIndefinitely: {
    description: 'Text displayed when an order is on hold indefinitely with no end date',
    defaultMessage: 'No end date',
    id: 'ffVVY+',
  },
  paidDate: {
    description: 'Label for the date that the order was paid on',
    defaultMessage: 'Date Paid',
    id: 'XeYeKC',
  },
  assignedTo: {
    description: 'Label for the name of the user that the order is assigned to',
    defaultMessage: 'Assigned To',
    id: 'BKyl9O',
  },
  gift: {
    description: 'Label for the gift toggler',
    defaultMessage: 'This is a gift',
    id: 'k91F7E',
  },
  saveButton: {
    description: 'save button for the edit amounts modal',
    defaultMessage: 'Save Changes',
    id: '+IXkyw',
  },
  shipmentLabel: {
    description: 'label for the shipment in the edit amounts modal',
    defaultMessage: 'Shipment {index}',
    id: 'DMDha/',
  },
  order: {
    description: 'label for the order in the edit amounts modal',
    defaultMessage: 'Order',
    id: 'CWsI6H',
  },
  editAmountsHeader: {
    description: 'header for the edit amounts modal',
    defaultMessage:
      'Edit the amounts for shipping, tax, and total paid for each shipment. The shipment amounts will add up to the order total.',
    id: 'GVBOfc',
  },
  editAmountsTitle: {
    description: 'title for the edit amounts modal',
    defaultMessage: 'Edit Shipment Amounts',
    id: '7u0flk',
  },
  errorBannerText: {
    defaultMessage: 'ShipStation could not save your changes. Please Cancel, then try to make your changes again. ',
    id: 'U6Z0/h',
    description: 'description of what went wrong when trying to save a piece of data from the shipment details section',
  },
  batchLabel: {
    description: 'label for a button that opens a modal which allows the user to add shipment to batch',
    defaultMessage: 'Batch',
    id: 'sWaVkl',
  },
  addToBatch: {
    description: 'label for a button that opens a modal which allows the user to add shipment to batch',
    defaultMessage: 'Add To Batch',
    id: 'X4tgG1',
  },
  addShipmentToBatchErrorTitle: {
    description: 'Adding a shipment to a batch error title',
    defaultMessage: 'Unable to Add Shipment to Batch',
    id: 'IYaX7d',
  },
  addShipmentToBatchErrorMessage: {
    description: 'Adding a shipment to a batch error message',
    defaultMessage: 'We were unable to add Shipment {shipmentNumber} (of {shipmentCount}) to Batch: {batchName}. Please try again.',
    id: 'uUe21x',
  },
  addShipmentToBatchSuccessTitle: {
    description: 'Adding a shipment to a batch success title',
    defaultMessage: 'Shipment Successfully Added to Batch',
    id: 'KASnIY',
  },
  addShipmentToBatchSuccessMessage: {
    description: 'Adding a shipment to a batch success message',
    defaultMessage: 'Shipment {shipmentNumber} (of {shipmentCount}) has been successfully added to Batch: {batchName}.',
    id: '6/GMde',
  },
  createBatchAndAddShipmentErrorTitle: {
    description: 'Creating batch error title',
    defaultMessage: 'Unable to Create a New Batch',
    id: 'T0nejC',
  },
  createBatchAndAddShipmentErrorMessage: {
    description: 'Creating batch error message',
    defaultMessage: 'We were unable to add Shipment {shipmentNumber} (of {shipmentCount}) to a new Batch. Please try again.',
    id: '8/LZwo',
  },
  createBatchAndAddShipmentSuccessTitle: {
    description: 'Creating batch success title',
    defaultMessage: 'Batch Successfully Created',
    id: '9PjT/Z',
  },
  createBatchAndAddShipmentSuccessMessage: {
    description: 'Adding a shipment to a batch success message',
    defaultMessage: 'Shipment {shipmentNumber} (of {shipmentCount}) has been successfully added to Batch: {batchName}.',
    id: '6/GMde',
  },
  deliverByDateTooltip: {
    description: 'The tooltip message for the info icon next to the deliver by date',
    defaultMessage: 'The date and time are displayed according to your ShipStation timezone setting and may differ from other systems.',
    id: 'hJ1TLl',
  },
  recipientTaxInformationLabel: {
    description: 'Label for the recipient tax information',
    defaultMessage: 'Recipient Tax Information',
    id: 'i6yUn8',
  },
  demoTooltipText: {
    description: 'Tooltip text for the demo green star on the Shipment Details section',
    defaultMessage: 'Here you can edit shipment details like the recipient address, phone, email, as well as certain payment fields.',
    id: 'loGUBG',
  },
  demoTooltipAltText: {
    description: 'Alt text for the demo green star on the Shipment Details section',
    defaultMessage: 'Green star tooltip explaining Shipment Details',
    id: 'OEqSlI',
  },
});

export const errorMessages = defineMessages({
  errorNotificationTitle: {
    defaultMessage: 'Error Saving',
    id: '8ktNIE',
    description: 'title on error notification when there is an error persisting the data',
  },
  errorNotificationBody: {
    defaultMessage: 'We encountered an issue saving. Please try again.',
    id: 'JQPobL',
    description: 'description of what went wrong when trying to save a piece of data from the shipment details section',
  },
});

export default messages;
